<template>
  <UpsellItemBase
    :title="partName"
    :price="upsell.product.price"
    :upsell="upsell"
    :sku="upsell.product.legacySKU"
    :index="index"
  >
    <template #content>
      <ChoiceSelect
        :customised-product="upsell.product"
        :choices="upsell.availableOptions.slice(0, 5)"
        :part="upsell.part"
        shape="circle"
        display="flex"
        wrap
        size="small"
        :class="$b('swatch-select')"
        background-style="transparent"
        @select="({ sku }) => selectedOptionChanged(sku)"
      />
    </template>
  </UpsellItemBase>
</template>

<script>
export default {
  name: 'UpsellItemConversionKit',

  props: {
    upsell: { type: Object, required: true },
    index: { type: Number, default: 0 }
  },

  setup() {
    const shopifyStore = useShopifyStore()

    return {
      shopifyStore
    }
  },

  data() {
    return {
      selectedOptionInCart: false,
    }
  },

  computed: {
    partName() {
      if (!this.upsell.product?.choices) return ''

      const choice =
        this.upsell.product?.choices[this.upsell.part.stockManagedSKUPrefix]

      const name = choice?.name

      return `${name} <nobr>Frame Kit</nobr>`
    },
  },

  methods: {
    selectedOptionChanged(sku) {
      this.upsell.product.setChoice(sku)
    },
  },
}
</script>

<style lang="postcss">
.UpsellItemConversionKit__swatch-select {
  @apply mt-3;
}
</style>
